export const ROUTES = {
    HOME: 'home',
    GROUPS: 'groups',
    EVENTS: 'events',
    COLLECTIONS: 'collections',
    PROFILE: 'profile',
    UPLOAD: 'upload'
};